export const endorsements_inside = {
  block: 'endorsements_three_columns_images_inside',
  args: {},
};
